import { Component, computed, inject, signal } from '@angular/core';
import {
  ModalNotificationRegistryService,
  ModalNotificationMultipleService,
  ModalTriggerConfiguration,
  ModalType
} from '@tdwb/core';
import { ModalNotificationContentComponent } from '../modal-notification-content.component';
import { ModalNotificationHeaderComponent } from '../header/modal-notification-header.component';
import { ModalNotificationFooterComponent } from '../footer/modal-notification-footer.component';

@Component({
  imports: [
    ModalNotificationHeaderComponent,
    ModalNotificationFooterComponent,
    ModalNotificationContentComponent
  ],
  selector: 'td-wb-modal-notification-whats-new',
  templateUrl: 'modal-notification-whats-new.component.html',
  styleUrls: ['modal-notification-whats-new.component.scss']
})
export class ModalNotificationWhatsNewComponent {
  readonly modalType: ModalType = ModalType.WHATS_NEW;
  protected readonly step = signal(0);

  private readonly multipleService = inject(ModalNotificationMultipleService);
  private readonly modalNotificationInvocationRegistrationService = inject(ModalNotificationRegistryService);

  protected readonly subModals: Array<ModalTriggerConfiguration> = this.multipleService.getMultipleWhatsNewModal();
  protected readonly totalSubModals: number = this.subModals.length;
  protected readonly currentTriggerId = computed(() => this.subModals[this.step()]?.id);

  protected goToSelected(index: number): void {
    this.step.set(index);
    this.markTheStepAsViewed(index);
  }

  private markTheStepAsViewed(index: number): void {
    const triggerContent = this.subModals[index];

    if (triggerContent && !this.modalNotificationInvocationRegistrationService.checkIfContentHasBeenLaunched(triggerContent)) {
      this.modalNotificationInvocationRegistrationService.registerLaunch(triggerContent);
    }
  }
}
